import { render, staticRenderFns } from "./TreeselectProducts.vue?vue&type=template&id=1a193664&"
import script from "./TreeselectProducts.vue?vue&type=script&lang=js&"
export * from "./TreeselectProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a193664')) {
      api.createRecord('1a193664', component.options)
    } else {
      api.reload('1a193664', component.options)
    }
    module.hot.accept("./TreeselectProducts.vue?vue&type=template&id=1a193664&", function () {
      api.rerender('1a193664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/TreeselectProducts.vue"
export default component.exports